import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import EmailPreferencesApi from '@infrastructure/email-preferences-api';
export const getAllEmailPreferencesAsync = createAsyncThunk('emailPreferences/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await EmailPreferencesApi.getAllEmailPreferences();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEmailPreferenceByIdAsync = createAsyncThunk('emailPreferences/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await EmailPreferencesApi.getEmailPreferenceById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEmailPreferenceAsync = createAsyncThunk('emailPreferences/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await EmailPreferencesApi.createEmailPreference(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEmailPreferenceAsync = createAsyncThunk('emailPreferences/update', async (payload, { rejectWithValue }) => {
    try {
        const { id, ...updateData } = payload;
        const response = await EmailPreferencesApi.updateEmailPreference(id, updateData);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
